import styled from 'styled-components';

export const TitleWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 30px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;

export const DescriptionWrapper = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;
